/**
 * @flow
 *
 * ErrorBoundary component for catching the error and displaying SomethingWentWrong page
 */

import React, { Component } from "react";
import SomethingWentWrong from "./SomethingWentWrong";
import log from "common/utils/logger";

type Props = {
  children: any,
};

type State = {
  hasError: boolean,
};

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, info: Object) {
    // Display fallback UI
    log(error, info);
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <SomethingWentWrong
          onResolve={() => this.setState({ hasError: false })}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
